import React, { useState } from 'react';
import { Accordion, Navbar, Nav, Offcanvas } from 'react-bootstrap';
import { FiChevronDown } from "react-icons/fi";
import { Link, NavLink } from 'react-router-dom';
import { useCart } from '../../../context/CartContext.jsx';
import { useWishlist } from '../../../context/WishlistContext.jsx';
import { useUser } from '../../../context/UserContext.jsx';
import { headerData } from '../../data/headerData';
import { FaShoppingCart, FaFacebookF, FaInstagram, FaTwitter, FaPinterestP, FaRegHeart } from "react-icons/fa";



const HeaderNavbar = () => {
    const { cartCount } = useCart();
    const { wishlistCount } = useWishlist();
    const { profileImage } = useUser();
    const [show, setShow] = useState(false);
    const [activeLink, setActiveLink] = useState();

    const handleNavLinkClick = () => {
        window.scrollTo(0, 0);
        handleParentNavLeave()
    };

    const toggleOffCanvas = () => {
        setShow(!show);
    };

    const executeMultipleFunctions = () => {
        toggleOffCanvas();
        handleNavLinkClick();
    }

    const handleParentNavHover = (index) => {
        setActiveLink(index);
    };

    const handleParentNavLeave = () => {
        setActiveLink(null);
    };

    return (
        <Navbar expand="xl">
            <div className="container-fluid">
                <Link to={"/"}><img className="logo" src={"/images/v2collection-logo.svg"} alt='logo' /></Link>
                <div className='d-flex align-items-center gap-3'>
                    <Link to="/wishlist" className='cartBtn position-relative d-xl-none'>
                        <FaRegHeart size={24} color="#000" />
                        {wishlistCount > 0 && (
                            <span className="cart-badge bg-danger">{wishlistCount}</span>
                        )}
                    </Link>
                    <Link to="/cart" className='cartBtn position-relative d-xl-none'>
                        <FaShoppingCart size={24} color="#000" />
                        {cartCount > 0 && (
                            <span className="cart-badge">{cartCount}</span>
                        )}
                    </Link>
                    <Link to="/profile-account" className='profileBtn d-xl-none'><img className='profile ' src={profileImage} alt="" /></Link>
                    <Navbar.Toggle onClick={toggleOffCanvas} aria-controls="offcanvasNavbar-expand-xl" />
                </div>
                <Navbar.Offcanvas
                    show={show}
                    onHide={toggleOffCanvas}
                    id="offcanvasNavbar-expand-xl"
                    aria-labelledby="offcanvasNavbarLabel-expand-xl"
                    placement="start"
                    className="premium-offcanvas"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel-expand-xl">
                            <Link to="/" onClick={toggleOffCanvas}>
                                <img className="sidebar-logo" src="/images/v2collection-logo.svg" alt="logo" />
                            </Link>
                        </Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="d-flex flex-column h-100">
                        <Nav className="justify-content-start justify-content-xl-end flex-grow-1">
                            <ul className="d-none d-xl-flex desktopMenu navList">
                                {headerData.map((navItem, index) => (
                                    <li
                                        key={index}
                                        className="navItemWrap"
                                        onMouseEnter={() => handleParentNavHover(index)}
                                        onMouseLeave={handleParentNavLeave}
                                    >
                                        <NavLink
                                            to={navItem.link}
                                            className={`navItem mb-0 ${navItem?.customClass}`}
                                            onClick={handleNavLinkClick}
                                        >
                                            {navItem.title}
                                            {navItem.subMenu && <FiChevronDown className="fs-large" />}
                                        </NavLink>
                                        {navItem.subMenu && activeLink === index && (
                                            <div className="megaMenuWrapper">
                                                {navItem.subMenu.map((subMenu, index) => (
                                                    <div key={index} className="menuWrap">
                                                        <h6 className="title-sm fw-semibold fontInter">{subMenu.subtitle}</h6>
                                                        <ul>
                                                            {subMenu.subLinks.map((item) => (
                                                                <li key={item.id}>
                                                                    <NavLink
                                                                        to={item.link}
                                                                        className="itemLink"
                                                                        onClick={handleNavLinkClick}
                                                                    >
                                                                        {item.title}
                                                                    </NavLink>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </li>
                                ))}
                                <Link to="/wishlist" className='cartBtn position-relative ms-3' title="Wishlist">
                                    <FaRegHeart size={24} color="#000" />
                                    {wishlistCount > 0 && (
                                        <span className="cart-badge bg-danger">{wishlistCount}</span>
                                    )}
                                </Link>
                                <Link to="/cart" className='cartBtn position-relative ms-3' title="Cart">
                                    <FaShoppingCart size={24} color="#000" />
                                    {cartCount > 0 && (
                                        <span className="cart-badge">{cartCount}</span>
                                    )}
                                </Link>
                                <Link to="/profile-account" className='profileBtn ms-3'><img className='profile ' src={profileImage} alt="" /></Link>

                            </ul>

                            <ul className='d-xl-none mobileMenu navList'>
                                {headerData && headerData.map((item, index) => {
                                    return (
                                        <li key={index} className="navItemWrap animated-item" style={{ "--animation-order": index }}>
                                            {
                                                item.subMenu ? (
                                                    <Accordion className='drops'>
                                                        <Accordion.Item eventKey={item.eventKey}>
                                                            <Accordion.Header>{item.title}</Accordion.Header>
                                                            {item.subMenu && item.subMenu.map((ele, index) => (
                                                                <Accordion.Body key={index}>
                                                                    <Accordion className='drops'>
                                                                        <Accordion.Item eventKey={item.eventKey}>
                                                                            <Accordion.Header>{ele.subtitle}</Accordion.Header>
                                                                            <Accordion.Body>
                                                                                <ul>
                                                                                    {ele.subLinks && ele.subLinks.map((item, index) => (
                                                                                        <li key={index}>
                                                                                            <NavLink onClick={executeMultipleFunctions} to={item.link} className='itemLink'>{item.title}</NavLink>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </Accordion.Body>
                                                                        </Accordion.Item>
                                                                    </Accordion>
                                                                </Accordion.Body>
                                                            ))}
                                                        </Accordion.Item>
                                                    </Accordion>
                                                )
                                                    :
                                                    <NavLink to={item.link} onClick={executeMultipleFunctions} className='navItem'>{item.title}</NavLink>
                                            }
                                        </li>
                                    )
                                }
                                )}
                            </ul>
                        </Nav>

                        <div className="sidebar-footer mt-auto pt-4 border-top d-xl-none">
                            <div className="social-links-sidebar d-flex gap-3 mb-3">
                                <a href="#!" className="social-icon-box" onClick={(e) => e.preventDefault()}><FaFacebookF /></a>
                                <a href="#!" className="social-icon-box" onClick={(e) => e.preventDefault()}><FaInstagram /></a>
                                <a href="#!" className="social-icon-box" onClick={(e) => e.preventDefault()}><FaTwitter /></a>
                                <a href="#!" className="social-icon-box" onClick={(e) => e.preventDefault()}><FaPinterestP /></a>
                            </div>
                            <div className="contact-info-sidebar">
                                <p className="mb-1"><small className="text-muted">Need help?</small></p>
                                <h6 className="fw-bold fs-6">support@v2collection.com</h6>
                            </div>
                        </div>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </div>
        </Navbar>
    );
};

export default HeaderNavbar;
